'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var passportInformation = {
    MIDDLE_NAME: (0, _reactIntl.defineMessages)({
        NO_MIDDLE_NAME: {
            'id': 'formOverrides.passportInformation.NO_MIDDLE_NAME',
            'defaultMessage': 'There is no middle name listed on my passport.'
        }
    })
};

exports.default = passportInformation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOverrides/passportInformation.js
// module id = 1385
// module chunks = 0